import { zIndices } from './zindex';
import { colors } from './colors';

export default {
  accessibility: { targetSize: 44 },
  animations: { defaultDuration: 0.3, defaultTimingFunction: 'ease-out' },
  breakpoints: { xs: 0, sm: 321, md: 481, lg: 769, xl: 1024, xxl: 1281 },
  colors: {
    white: 'var(--white)',
    gray100: 'var(--gray100)',
    gray200: 'var(--gray200)',
    gray300: 'var(--gray300)',
    gray400: 'var(--gray400)',
    gray500: 'var(--gray500)',
    gray600: 'var(--gray600)',
    black: 'var(--black)',
    trueBlack: 'var(--trueBlack)',
    coolGray100: 'var(--coolGray100)',
    coolGray200: 'var(--coolGray200)',
    coolGray300: 'var(--coolGray300)',
    coolGray400: 'var(--coolGray400)',
    coolGray500: 'var(--coolGray500)',
    coolGray600: 'var(--coolGray600)',
    blue100: 'var(--blue100)',
    blue200: 'var(--blue200)',
    blue300: 'var(--blue300)',
    blue375: 'var(--blue375)',
    blue400: 'var(--blue400)',
    blue500: 'var(--blue500)',
    blue600: 'var(--blue600)',
    yellow100: 'var(--yellow100)',
    yellow200: 'var(--yellow200)',
    yellow300: 'var(--yellow300)',
    yellow400: 'var(--yellow400)',
    yellow500: 'var(--yellow500)',
    yellow600: 'var(--yellow600)',
    orange100: 'var(--orange100)',
    orange200: 'var(--orange200)',
    orange300: 'var(--orange300)',
    orange400: 'var(--orange400)',
    orange500: 'var(--orange500)',
    orange600: 'var(--orange600)',
    green100: 'var(--green100)',
    green200: 'var(--green200)',
    green300: 'var(--green300)',
    green400: 'var(--green400)',
    green500: 'var(--green500)',
    green600: 'var(--green600)',
    aqua100: 'var(--aqua100)',
    aqua200: 'var(--aqua200)',
    aqua300: 'var(--aqua300)',
    aqua400: 'var(--aqua400)',
    aqua500: 'var(--aqua500)',
    aqua600: 'var(--aqua600)',
    purple100: 'var(--purple100)',
    purple200: 'var(--purple200)',
    purple300: 'var(--purple300)',
    purple400: 'var(--purple400)',
    purple500: 'var(--purple500)',
    purple600: 'var(--purple600)',
    red100: 'var(--red100)',
    red200: 'var(--red200)',
    red300: 'var(--red300)',
    red400: 'var(--red400)',
    red500: 'var(--red500)',
    red600: 'var(--red600)',
    orangeRed100: 'var(--orangeRed100)',
    orangeRed200: 'var(--orangeRed200)',
    orangeRed300: 'var(--orangeRed300)',
    orangeRed400: 'var(--orangeRed400)',
    orangeRed500: 'var(--orangeRed500)',
    orangeRed600: 'var(--orangeRed600)',
    facebook: 'var(--facebook)',
    twitter: 'var(--twitter)',
    linkedIn: 'var(--linkedIn)',
    none: 'var(--none)',
    transparent: 'var(--transparent)',
    brand: 'var(--blue400)',
    brandSecondary: 'var(--yellow400)',
    backgroundBrand: 'var(--blue400)',
    textWhite: 'var(--white)',
    textLight: 'var(--gray400)',
    textMedium: 'var(--coolGray500)',
    textDark: 'var(--gray600)',
    link: 'var(--blue500)',
    linkVisited: 'var(--purple600)',
    linkHover: 'var(--blue600)',
    linkActive: 'var(--blue600)',
    backgroundAqua: 'var(--aqua100)',
    backgroundBlue: 'var(--blue100)',
    backgroundGreen: 'var(--green100)',
    backgroundOrange: 'var(--orange100)',
    backgroundOrangeRed: 'var(--orangeRed100)',
    backgroundPurple: 'var(--purple100)',
    backgroundRed: 'var(--red100)',
    backgroundYellow: 'var(--yellow100)',
    backgroundDarkAqua: 'var(--aqua600)',
    backgroundDarkBlue: 'var(--blue600)',
    backgroundDarkGreen: 'var(--green600)',
    backgroundDarkOrange: 'var(--orange600)',
    backgroundDarkOrangeRed: 'var(--orangeRed600)',
    backgroundDarkPurple: 'var(--purple600)',
    backgroundDarkRed: 'var(--red600)',
    backgroundDarkYellow: 'var(--yellow600)',
    backgroundWhite: 'var(--white)',
    backgroundLight: 'var(--gray100)',
    backgroundDark: 'var(--gray600)',
    borderAqua: 'var(--aqua500)',
    borderBlue: 'var(--blue500)',
    borderGreen: 'var(--green500)',
    borderOrange: 'var(--orange500)',
    borderOrangeRed: 'var(--red500)',
    borderPurple: 'var(--purple500)',
    borderRed: 'var(--red500)',
    borderYellow: 'var(--yellow500)',
    borderLight: 'var(--gray300)',
    borderDark: 'var(--gray400)',
    offMarket: 'var(--gray400)',
    comingSoon: 'var(--blue400)',
    recentlySold: 'var(--yellow300)',
    forRent: 'var(--purple400)',
    forSale: 'var(--red400)',
    primary100: 'var(--blue100)',
    primary200: 'var(--blue200)',
    primary300: 'var(--blue300)',
    primary400: 'var(--blue400)',
    primary500: 'var(--blue500)',
    primary600: 'var(--blue600)',
    secondary100: 'var(--yellow100)',
    secondary200: 'var(--yellow200)',
    secondary300: 'var(--yellow300)',
    secondary400: 'var(--yellow400)',
    secondary500: 'var(--yellow500)',
    secondary600: 'var(--yellow600)',
    ...colors,
  },
  defaultUnit: 'px',
  fonts: {
    sansSerif: '"Open Sans","Adjusted Arial",Tahoma,Geneva,sans-serif',
    serif:
      '"Ivar Headline","Ivar Headline Subset","Adjusted Times","Adjusted Times New Roman","Times New Roman",serif',
  },
  fontSizes: {
    h0: 96,
    h1: 60,
    h2: 48,
    h3: 36,
    h4: 24,
    h5: 20,
    h6: 16,
    bodyHeading: 16,
    body: 16,
    bodySmallHeading: 14,
    bodySmall: 14,
    finePrintHeading: 12,
    finePrint: 12,
    legal: 10,
  },
  fontWeights: {
    h0: 700,
    h1: 700,
    h2: 700,
    h3: 700,
    h4: 700,
    h5: 700,
    h6: 700,
    bodyHeading: 700,
    body: 400,
    bodySmallHeading: 700,
    bodySmall: 400,
    finePrintHeading: 700,
    finePrint: 400,
    legal: 400,
  },
  gridBase: 8,
  icons: { sizes: { xs: 16, sm: 24, md: 32, lg: 44 } },
  detailedIcons: { sizes: { sm: 44 } },
  lineHeights: {
    h0: 112,
    h1: 72,
    h2: 64,
    h3: 40,
    h4: 32,
    h5: 24,
    h6: 24,
    bodyHeading: 24,
    body: 24,
    bodySmallHeading: 24,
    bodySmall: 24,
    finePrintHeading: 16,
    finePrint: 16,
    legal: 16,
  },
  opacities: {
    opacity100: 0.2,
    opacity200: 0.4,
    opacity300: 0.6,
    opacity400: 0.8,
    disabled: 0.4,
    mask: 0.2,
  },
  radii: { sm: 2, md: 4, lg: 8, ellipse: '50%', pill: '999px' },
  shadows: {
    shadow100: '0 2px 4px 0 rgba(0, 0, 0, 0.3)',
    shadow200: '0 4px 8px 0 rgba(0, 0, 0, 0.3)',
    shadow300: '0 8px 12px 0 rgba(0, 0, 0, 0.3)',
    shadow400: '0 15px 30px 0 rgba(0, 0, 0, 0.3)',
    focus:
      '0 0 0px 1px var(--white),0 0 2px 3px var(--blue300),0 0 2px 4px var(--blue400)',
  },
  spacing: { xxs: 4, xs: 8, sm: 16, md: 24, lg: 32, xl: 48 },
  sizes: { heights: { xs: 28, sm: 36, md: 44, lg: 56 } },
  zIndices: {
    modal: 100002,
    popover: 100011,
    dialog: 100013,
    toast: 200000,
    ...zIndices,
  },
  grid: { columns: 12, columnWidth: 88, gap: 16 },
  status: {
    fontType: 'body',
    iconSize: 24,
    error: {
      background: 'var(--red100)',
      border: 'var(--red500)',
      foreground: 'var(--red500)',
      fontColor: 'var(--red600)',
      darkBackground: 'var(--red600)',
    },
    info: {
      background: 'var(--blue100)',
      border: 'var(--blue500)',
      foreground: 'var(--blue600)',
      fontColor: 'var(--blue600)',
      darkBackground: 'var(--blue600)',
    },
    success: {
      background: 'var(--green100)',
      border: 'var(--green500)',
      foreground: 'var(--green500)',
      fontColor: 'var(--green600)',
      darkBackground: 'var(--green600)',
    },
    warning: {
      background: 'var(--yellow100)',
      border: 'var(--yellow500)',
      foreground: 'var(--orange400)',
      fontColor: 'var(--yellow600)',
      darkBackground: 'var(--orange500)',
    },
    transient: { foreground: 'var(--blue400)' },
  },
  AccordionHeader: {
    backgroundColor: 'var(--white)',
    backgroundColorHover: 'var(--coolGray100)',
    borderRadius: 4,
    padding: 16,
  },
  AccordionItem: {
    borderColor: 'var(--gray300)',
    borderRadius: 4,
    borderSize: 1,
    spacing: 8,
  },
  AccordionPanel: {
    backgroundColor: 'var(--white)',
    borderColor: 'var(--gray300)',
    borderRadius: 4,
    borderSize: 1,
    padding: 16,
  },
  Avatar: {
    sizes: { xs: 24, sm: 32, md: 48, lg: 64, xl: 96, xxl: 160 },
    fontTypes: {
      xs: 'bodySmallHeading',
      sm: 'h6',
      md: 'h5',
      lg: 'h4',
      xl: 'h3',
      xxl: 'h1',
    },
    iconColor: 'var(--gray400)',
    backgroundColor: 'var(--gray200)',
  },
  AvatarBadge: {
    badgeSizes: { xxl: 48, xl: 36, lg: 28 },
    iconSizes: { xxl: 32, xl: 24, lg: 16 },
    backgroundColor: 'var(--blue400)',
    foregroundColor: 'var(--white)',
    borderColor: 'var(--white)',
  },
  Button: {
    fontType: 'bodyHeading',
    fontTypeSmall: 'bodySmallHeading',
    borderRadius: 4,
    borderWidth: 1,
    horizontalPadding: 16,
    primary: {
      fontColor: 'var(--white)',
      fontColorHover: 'var(--white)',
      fontColorActive: 'var(--white)',
      fontColorPressed: 'var(--white)',
      borderColor: 'var(--blue400)',
      borderColorHover: 'var(--blue500)',
      borderColorActive: 'var(--blue600)',
      borderColorPressed: 'var(--blue600)',
      backgroundColor: 'var(--blue400)',
      backgroundColorHover: 'var(--blue500)',
      backgroundColorActive: 'var(--blue600)',
      backgroundColorPressed: 'var(--blue600)',
    },
    secondary: {
      fontColor: 'var(--blue400)',
      fontColorHover: 'var(--blue500)',
      fontColorActive: 'var(--blue600)',
      fontColorPressed: 'var(--white)',
      borderColor: 'var(--blue400)',
      borderColorHover: 'var(--blue500)',
      borderColorActive: 'var(--blue600)',
      borderColorPressed: 'var(--blue600)',
      backgroundColor: 'var(--white)',
      backgroundColorHover: 'var(--blue100)',
      backgroundColorActive: 'var(--blue200)',
      backgroundColorPressed: 'var(--blue600)',
    },
    tertiary: {
      fontColor: 'var(--gray600)',
      fontColorHover: 'var(--gray600)',
      fontColorActive: 'var(--gray600)',
      fontColorPressed: 'var(--gray600)',
      borderColor: 'var(--gray400)',
      borderColorHover: 'var(--gray400)',
      borderColorActive: 'var(--gray500)',
      borderColorPressed: 'var(--blue400)',
      backgroundColor: 'var(--white)',
      backgroundColorHover: 'var(--gray200)',
      backgroundColorActive: 'var(--gray300)',
      backgroundColorPressed: 'var(--blue100)',
    },
    caution: {
      fontColor: 'var(--white)',
      fontColorHover: 'var(--red600)',
      fontColorActive: 'var(--white)',
      fontColorPressed: 'var(--white)',
      borderColor: 'var(--red500)',
      borderColorHover: 'var(--red600)',
      borderColorActive: 'var(--red600)',
      borderColorPressed: 'var(--red600)',
      backgroundColor: 'var(--red500)',
      backgroundColorHover: 'var(--white)',
      backgroundColorActive: 'var(--red600)',
      backgroundColorPressed: 'var(--red600)',
    },
    primaryInverse: {
      fontColor: 'var(--blue400)',
      fontColorHover: 'var(--blue500)',
      fontColorActive: 'var(--blue600)',
      borderColor: 'var(--white)',
      borderColorHover: 'var(--white)',
      borderColorActive: 'var(--white)',
      backgroundColor: 'var(--white)',
      backgroundColorHover: 'var(--blue100)',
      backgroundColorActive: 'var(--blue200)',
    },
    secondaryInverse: {
      fontColor: 'var(--white)',
      fontColorHover: 'var(--gray600)',
      fontColorActive: 'var(--gray600)',
      borderColor: 'var(--white)',
      borderColorHover: 'var(--white)',
      borderColorActive: 'var(--white)',
      backgroundColor: 'var(--transparent)',
      backgroundColorHover: 'var(--gray200)',
      backgroundColorActive: 'var(--gray300)',
    },
  },
  Card: {
    borderColor: 'var(--gray300)',
    borderColorPrimary: 'var(--blue400)',
    backgroundColor: 'var(--white)',
    separatorColor: 'var(--gray300)',
  },
  CardButton: { fontType: 'h6', fontColor: 'var(--blue400)' },
  CardHeader: { fontType: 'h5' },
  CloseButton: {
    buttonSize: 24,
    iconColor: 'var(--black)',
    backgroundColor: 'var(--gray200)',
    backgroundColorInverse: 'rgba(255, 255, 255, 0.3)',
  },
  ComboboxInput: { tagMargin: 4, minInputWidth: '25%' },
  DatePicker: { caretSize: 28, caretIconSize: 10 },
  DetailedIcon: {
    noFill: 'var(--none)',
    white: 'var(--white)',
    info: {
      foregroundColor: 'var(--blue500)',
      secondaryColor: 'var(--blue300)',
      accentColor: 'var(--yellow400)',
    },
    success: {
      foregroundColor: 'var(--green600)',
      secondaryColor: 'var(--green200)',
      accentColor: 'var(--yellow400)',
    },
  },
  Dialog: {
    minWidth: 200,
    maxWidth: 360,
    headingFontType: 'h5',
    backgroundColor: 'var(--white)',
    boxShadow: '0 8px 12px 0 rgba(0, 0, 0, 0.3)',
  },
  Divider: {
    lengths: { auto: 'auto', fixed: 144, fluid: '100%' },
    regular: { backgroundColor: 'var(--gray300)', thickness: 1 },
    emphasized: { backgroundColor: 'var(--yellow300)', thickness: 2 },
  },
  Dropdown: { horizontalSpacing: 16, verticalSpacing: 12 },
  DropdownHeading: {
    fontType: 'bodySmallHeading',
    fontColor: 'var(--coolGray500)',
    iconSize: 'sm',
    backgroundColor: 'var(--coolGray100)',
    horizontalSpacing: 16,
    verticalSpacing: 12,
  },
  DropdownIcon: { iconColor: 'var(--blue400)' },
  FormHelp: { fontType: 'finePrint', fontColor: 'var(--coolGray500)' },
  Gleam: {
    height: 20,
    padding: 6,
    fontType: 'bodySmallHeading',
    default: {
      fontColor: 'var(--white)',
      backgroundColor: 'var(--orangeRed400)',
      inverse: {
        fontColor: 'var(--white)',
        backgroundColor: 'var(--orangeRed400)',
      },
    },
    info: {
      fontColor: 'var(--white)',
      backgroundColor: 'var(--blue500)',
      inverse: {
        fontColor: 'var(--blue600)',
        backgroundColor: 'var(--blue200)',
      },
    },
    new: {
      fontColor: 'var(--white)',
      backgroundColor: 'var(--green500)',
      inverse: {
        fontColor: 'var(--green600)',
        backgroundColor: 'var(--green100)',
      },
    },
  },
  GridContent: { backgroundColor: 'var(--white)', borderRadius: 4 },
  Input: {
    fontType: 'body',
    borderWidth: 1,
    horizontalSpacing: 16,
    fontColor: 'var(--gray600)',
    fontColorPlaceholder: 'var(--coolGray500)',
    backgroundColor: 'var(--coolGray100)',
    backgroundColorAutofill: 'var(--blue200)',
    backgroundColorInteractive: 'var(--white)',
    borderColor: 'var(--gray300)',
    borderColorError: 'var(--red600)',
    borderColorInteractive: 'var(--blue400)',
    adornmentColor: 'var(--gray500)',
  },
  Label: {
    fontTypes: { md: 'bodySmallHeading', lg: 'bodyHeading' },
    asteriskColor: 'var(--red600)',
    optionalColor: 'var(--coolGray500)',
  },
  LabeledControl: { fontType: 'body' },
  LabeledInput: {
    fontTypeInput: 'body',
    fontTypeLabel: 'finePrintHeading',
    scale: 0.75,
    transition: '0.15s all',
    verticalSpacing: 8,
    horizontalSpacing: 16,
    paddingBase: 15,
  },
  List: { fontType: 'body', borderColor: 'var(--gray300)', borderWidth: 1 },
  Listbox: { sizes: { md: 220 } },
  ListboxGroupLabel: {
    fontType: 'bodySmallHeading',
    fontColor: 'var(--coolGray500)',
    backgroundColor: 'var(--coolGray100)',
  },
  ListboxOption: {
    backgroundColorActive: 'var(--blue100)',
    fontType: 'body',
    iconSize: 'sm',
    iconColor: 'var(--coolGray500)',
    mediaSize: 24,
    metaColor: 'var(--coolGray500)',
    horizontalSpacing: 16,
    verticalSpacing: 12,
  },
  MenuContent: {
    fontType: 'finePrint',
    horizontalSpacing: 16,
    verticalSpacing: 12,
  },
  MenuItem: {
    backgroundColor: 'var(--white)',
    backgroundColorHover: 'var(--blue100)',
    fontColor: 'var(--gray600)',
    fontType: 'body',
    iconSize: 'sm',
    iconColor: 'var(--coolGray500)',
    horizontalSpacing: 16,
    verticalSpacing: 12,
  },
  Modal: { viewportPaddingVertical: 48, viewportPaddingHorizontal: 16 },
  ModalDialog: {
    padding: 16,
    separatorColor: 'var(--gray300)',
    sizes: { xs: 360, sm: 540, md: 720, lg: 900, xl: 1080, fullScreen: 100 },
  },
  Page: {
    backgroundColor: 'var(--coolGray100)',
    maxWidth: 1232,
    horizontalPadding: 24,
    horizontalPaddingMobile: 16,
    verticalMargin: 32,
  },
  PhotoCarousel: {
    animations: {
      defaultDuration: 0.2,
      defaultTimingFunction: 'cubic-bezier(.58, .92, .57, .92)',
    },
    controlIcon: {
      color: 'var(--white)',
      previous: { filter: 'drop-shadow(2px 0 2px rgba(0, 0, 0, 0.3))' },
      next: { filter: 'drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.3))' },
    },
    dot: {
      backgroundColor: 'var(--white)',
      position: { bottom: 6 },
      size: { sm: 4, md: 6, lg: 8 },
    },
    slide: {
      horizontalTranslations: { left: -100, center: 0, right: 100 },
      zIndices: { left: 1, center: 2, right: 1 },
    },
  },
  Popover: {
    maxHeight: 320,
    headingFontType: 'h6',
    padding: 16,
    arrowOuterSize: 40,
    arrowInnerSize: 17,
    arrowAlignStart: -9,
    arrowAlignCenter: 12,
    arrowAlignEnd: 31,
    separatorColor: 'var(--gray300)',
  },
  ProgressMeter: {
    sizes: { sm: 8, md: 16 },
    backgroundColor: 'var(--coolGray400)',
    borderRadius: 4,
    indicatorColorInProgress: 'var(--blue500)',
    indicatorColorCompleted: 'var(--green300)',
    transition: '0.2s ease-in-out',
  },
  ProgressStepper: {
    currentStepSize: 36,
    nonInteractiveStepSize: 4,
    interactiveStepSize: 20,
    nonInteractiveLabelColor: 'var(--coolGray500)',
    interactiveLabelColor: 'var(--blue500)',
    stepBorderWidth: 6,
    stepPaddingX: 2,
    tagMarginTop: 4,
    labelFontType: 'bodySmall',
    labelOffset: 12,
    backgroundColor: 'var(--coolGray400)',
    indicatorColor: 'var(--blue500)',
    stepBackgroundColor: 'var(--white)',
    activeStepBackgroundColor: 'var(--blue400)',
    activeStepBorderColor: 'var(--white)',
    activeStepLabelColor: 'var(--gray600)',
    activeStepBoxShadow: 'inset 0 0 0 2px var(--blue400)',
    boxShadowRing: '0 0 0 8px undefined',
    status: {
      complete: {
        foreground: 'var(--blue500)',
        boxShadow: 'inset 0 0 0 2px var(--blue500)',
      },
      incomplete: {
        foreground: 'var(--blue500)',
        boxShadow: 'inset 0 0 0 2px var(--blue500)',
      },
      warning: {
        foreground: 'var(--orange400)',
        boxShadow: 'inset 0 0 0 2px var(--blue500)',
        iconSize: 24,
        filler: { width: 4, height: 12 },
      },
      error: {
        foreground: 'var(--red500)',
        boxShadow: 'inset 0 0 0 2px var(--red500)',
      },
      none: { foreground: 'inherit', boxShadow: '' },
    },
  },
  PropertyCard: {
    badge: {
      backgroundColor: {
        default: 'black',
        notification: 'orangeRed400',
        zillow: 'blue400',
      },
      borderRadius: '999px',
      fontColor: 'var(--white)',
      fontType: 'finePrintHeading',
      horizontalPadding: 8,
      opacity: { default: 0.6, notification: 1, zillow: 1 },
      verticalPadding: 2,
    },
    cardBody: {
      borderRadius: 4,
      boxShadow: {
        flag: '0 4px 8px 0 rgba(0, 0, 0, 0.3)',
        hover: { flag: '0 8px 12px 0 rgba(0, 0, 0, 0.3)' },
      },
      gridTemplate: {
        large: '177px 1fr auto',
        small: '123px minmax(112px, 1fr)',
        horizontal: '116px 1fr',
        flag: '120px 1fr',
      },
    },
    data: {
      title: {
        fontColor: 'var(--gray600)',
        fontType: { large: 'h5', small: 'h6', horizontal: 'h5', flag: 'h6' },
      },
      body1: { fontColor: 'var(--gray600)', fontType: 'bodySmall' },
      body2: { fontColor: 'var(--gray600)', fontType: 'bodySmall' },
      body3: { fontColor: 'var(--gray600)', fontType: 'bodySmall' },
      additionalInfo: { fontColor: 'var(--coolGray500)', fontType: 'legal' },
    },
    fallbackImage: {
      fill: 'var(--coolGray300)',
      size: { large: 70, small: 42, horizontal: 42, flag: 32 },
    },
    gridTemplateAreas: {
      large: '"photo" "data" "flex"',
      small: '"photo" "data"',
      horizontal: '"photo data"',
      flag: '"photo data"',
    },
    loading: {
      backgroundColor: 'var(--gray200)',
      backgroundImage:
        'linear-gradient(to right, var(--gray200), var(--gray100), var(--gray200))',
    },
    maxWidth: { large: 386, small: 244, horizontal: 393, flag: 332 },
    minWidth: { large: 286, small: 144, horizontal: 293, flag: 232 },
    mls: {
      background:
        'linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 50%, rgba(0, 0, 0, 0.5) 100%)',
      fontColor: 'var(--white)',
      fontType: {
        large: 'finePrintHeading',
        small: 'legal',
        horizontal: 'legal',
        undefined: 'legal',
      },
      textShadow: '0 1px 1px rgba(0, 0, 0, 0.2)',
      logo: { maxHeight: 23, maxWidth: 100 },
    },
    photo: { backgroundBlur: 8, backgroundColor: 'var(--coolGray100)' },
    width: { flag: 282 },
  },
  Radio: {
    backgroundColor: 'var(--white)',
    borderColor: 'var(--gray400)',
    borderColorDisabled: 'var(--gray300)',
    borderWidth: 2,
    borderWidthChecked: 5,
    size: 20,
  },
  SearchBox: {
    boxShadow: '0 0 18px rgba(0, 0, 0, 0.1)',
    fontType: 'h6',
    height: 60,
    heightLarge: 70,
    iconSize: 16,
    iconSizeLarge: 22,
    iconColor: 'var(--gray500)',
  },
  Select: {
    chevronWidth: 40,
    chevronHeight: 28,
    chevronColor: 'var(--gray500)',
  },
  Slider: {
    thumbBackgroundColor: 'var(--blue400)',
    thumbBackgroundColorInteractive: 'var(--blue500)',
    thumbBorderColor: 'var(--white)',
    thumbBorderWidth: 4,
    thumbBoxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.3)',
    thumbLabelOffset: -60,
    thumbSize: 24,
    trackBackgroundColor: 'var(--gray300)',
    trackBackgroundColorSelected: 'var(--blue400)',
    trackHeight: 2,
  },
  SliderLabel: {
    caretSize: 8,
    fontType: 'body',
    fontColor: 'var(--gray600)',
    backgroundColor: 'var(--white)',
  },
  Switch: {
    transition: '0.4s all',
    iconColorOn: 'var(--blue400)',
    iconColorOff: 'var(--white)',
    iconBackgroundColorOn: 'var(--white)',
    iconBackgroundColorOff: 'var(--gray300)',
    backgroundColor: 'var(--gray200)',
    backgroundColorChecked: 'var(--blue400)',
    sizes: {
      lg: { height: 30, width: 50, padding: 5 },
      md: { height: 22, width: 38, padding: 4 },
    },
  },
  SwitchGroup: { borderColor: 'var(--gray300)' },
  Table: {
    borderColor: 'var(--gray300)',
    borderWidth: 1,
    cellBackgroundColorLight: 'var(--white)',
    cellBackgroundColorDark: 'var(--gray100)',
    fontType: { sm: 'bodySmall', md: 'bodySmall', lg: 'body' },
    headerBackgroundColorLight: 'var(--white)',
    headerBackgroundColorDark: 'var(--gray200)',
    headerFontType: {
      sm: 'bodySmallHeading',
      md: 'bodySmallHeading',
      lg: 'bodyHeading',
    },
    headerSortIconColor: 'var(--blue400)',
    horizontalPadding: { sm: 16, md: 16, lg: 16 },
    rowBackgroundColorHover: 'var(--blue100)',
    rowBackgroundColorSelected: 'var(--blue200)',
    verticalPadding: { sm: 8, md: 12, lg: 16 },
  },
  Tag: {
    colors: {
      fontType: 'body',
      iconSize: 24,
      error: {
        background: 'var(--red100)',
        border: 'var(--red500)',
        foreground: 'var(--red500)',
        fontColor: 'var(--red600)',
        darkBackground: 'var(--red600)',
      },
      info: { fontColor: 'var(--blue600)', background: 'var(--blue200)' },
      success: {
        background: 'var(--green100)',
        border: 'var(--green500)',
        foreground: 'var(--green500)',
        fontColor: 'var(--green600)',
        darkBackground: 'var(--green600)',
      },
      warning: {
        background: 'var(--yellow100)',
        border: 'var(--yellow500)',
        foreground: 'var(--orange400)',
        fontColor: 'var(--yellow600)',
        darkBackground: 'var(--orange500)',
      },
      transient: { foreground: 'var(--blue400)' },
      gray: { fontColor: 'var(--gray600)', background: 'var(--gray200)' },
      closeable: {
        fontColor: 'var(--gray600)',
        background: 'var(--coolGray300)',
      },
      purple: { fontColor: 'var(--purple600)', background: 'var(--purple100)' },
      aqua: { fontColor: 'var(--aqua600)', background: 'var(--aqua100)' },
      orange: { fontColor: 'var(--orange600)', background: 'var(--orange100)' },
      transparent: { fontColor: 'var(--white)', background: 'rgba(0,0,0,0.6)' },
    },
    fontTypes: { sm: 'finePrintHeading', md: 'bodySmallHeading' },
    horizontalPadding: { sm: 4, md: 8 },
    verticalPadding: 2,
    targetPadding: 8,
    closeButtonSize: 16,
  },
  Tabs: {
    backgroundColor: 'var(--white)',
    selectedTabIndicatorColor: 'var(--blue400)',
    selectedTabIndicatorHeight: 4,
  },
  TextButton: {
    fontColor: 'var(--blue500)',
    fontColorInverse: 'var(--white)',
    fontColorPrimary: 'var(--blue500)',
    fontColorSecondary: 'var(--gray600)',
    fontColorTertiary: 'var(--coolGray500)',
  },
  Toast: { maxWidth: 500 },
  TriggerButton: {
    helpCircleFillColor: 'var(--white)',
    helpCircleFillColorActive: 'var(--gray300)',
    helpCircleFillColorHover: 'var(--gray200)',
    helpCircleStrokeColor: 'var(--gray400)',
    helpCircleStrokeColorActive: 'var(--gray500)',
    helpCircleStrokeColorHover: 'var(--gray400)',
    helpQuestionFillColor: 'var(--gray600)',
    helpQuestionFillColorActive: 'var(--gray600)',
  },
  TriggerText: { borderBottomColor: 'var(--blue400)' },
  Upsell: {
    headingFontType: 'h6',
    rowMediaSize: 48,
    columnMediaSize: 80,
    fontColorInverse: 'var(--white)',
    iconBackgroundColorInteractive: 'rgba(255, 255, 255, 0.3)',
  },
  UpsellBanner: {
    fontType: 'h6',
    mediaSize: 44,
    boxShadow: '0 1px 1px 0 rgb(79, 79, 79, 0.3)',
  },
  VerticalNav: {
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.3)',
    backgroundColor: 'var(--white)',
    borderColor: 'var(--gray300)',
    borderRadius: 4,
  },
  VerticalNavItem: {
    backgroundColor: 'var(--transparent)',
    backgroundColorHover: 'var(--coolGray300)',
    backgroundColorActive: 'var(--blue200)',
    fontColor: 'var(--gray600)',
    fontType: 'body',
    fontWeightActive: 700,
    horizontalSpacing: 24,
    verticalSpacing: 12,
    borderColor: 'var(--transparent)',
    borderColorActive: 'var(--blue400)',
    borderWidth: 4,
    borderRadius: 4,
  },
};
